<template>
  <div v-if="showBadge" class="offer-more-content" :style="mergedStyle">
    <span class="more-content-number">{{ moreContentValue }}%</span>
    <span class="more-content-text">{{
      $t("shop.offers.more_contents2")
    }}</span>
  </div>
</template>

<script>
export default {
  name: "OfferMoreContent",
  props: {
    package: {
      type: Object,
      required: true,
    },
    displayConfig: {
      type: Object,
      default: null,
    },
    offerDisplayConfig: {
      type: Object,
      default: null,
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    showBadge() {
      // First check display_config, fallback to old payload location
      return (
        this.displayConfig?.more_content || this.package?.payload?.more_content
      );
    },
    moreContentValue() {
      // First check display_config, fallback to old payload location
      return (
        this.displayConfig?.more_content ||
        this.package?.payload?.more_content ||
        0
      );
    },
    hasGlowAnimation() {
      // Only enable animation if the color is explicitly set in display_config
      return !!this.offerDisplayConfig?.style?.["more-content-highlight-color"];
    },
    highlightColor() {
      return (
        this.offerDisplayConfig?.style?.["more-content-highlight-color"] ||
        "#FFD700"
      );
    },
    mergedStyle() {
      const style = { ...this.customStyle };

      // Only set CSS variable if animation is enabled
      if (this.hasGlowAnimation) {
        style["--glow-color"] = this.highlightColor;
      }

      return style;
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes glowPulse {
  0% {
    box-shadow: 0 0 10px var(--glow-color), 0 0 20px var(--glow-color),
      0 0 30px var(--glow-color);
  }
  50% {
    box-shadow: 0 0 20px var(--glow-color), 0 0 30px var(--glow-color),
      0 0 40px var(--glow-color);
  }
  100% {
    box-shadow: 0 0 10px var(--glow-color), 0 0 20px var(--glow-color),
      0 0 30px var(--glow-color);
  }
}

.offer-more-content {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.2;
  border-radius: 50%;
  transform: rotate(-15deg);
  z-index: 5;

  &.has-glow-animation {
    animation: glowPulse 2s ease-in-out infinite;
  }

  .more-content-number {
    display: block;
    line-height: 1;
  }

  .more-content-text {
    display: block;
    line-height: 1.1;
  }
}
</style>
